





































// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { useStore } from '@/store';

// components
import EditorText from '@/vue3/components/editor/EditorText.vue';

// primevue
import Button from 'primevue/button';

// hooks
import { useNotify } from '@/vue3/hooks/notifyHook';

export default defineComponent({
    components: {
        EditorText,
        Button,
    },
    setup() {
        // hooks
        const store = useStore();
        const { successToast, warnToast } = useNotify();

        // ref
        const airtableApiKey = ref<any>('');
        const airtableBaseKey = ref<any>('');
        const airtableTableName = ref<any>('');

        // methods
        const ApplyAirtableIntegrationData = (): void => {
            store.commit('setAirtableApiKey', airtableApiKey.value);
            store.commit('setAirtableBaseKey', airtableBaseKey.value);
            store.commit('setAirtableTableName', airtableTableName.value);

            if (
                airtableApiKey.value == '' ||
                airtableBaseKey == '' ||
                airtableTableName == ''
            ) {
                warnToast(`Please enter correct airtable data.`);
            } else {
                successToast(`Airtable integrated successfully.`);
            }
        };

        const setAirtableIntegrationData = () => {
            airtableApiKey.value = store.state.airtableApiKey;
            airtableBaseKey.value = store.state.airtableBaseKey;
            airtableTableName.value = store.state.airtableTableName;
        };

        const clearAirtableIntegrationData = () => {
            airtableApiKey.value = '';
            airtableBaseKey.value = '';
            airtableTableName.value = '';

            store.commit('setAirtableApiKey', airtableApiKey.value);
            store.commit('setAirtableBaseKey', airtableBaseKey.value);
            store.commit('setAirtableTableName', airtableTableName.value);
        };

        // lifycycle
        onMounted(() => {
            setAirtableIntegrationData();
        });

        return {
            airtableApiKey,
            airtableBaseKey,
            airtableTableName,
            ApplyAirtableIntegrationData,
            clearAirtableIntegrationData,
        };
    },
});
